import React from 'react'
import PropTypes from 'prop-types';
import './style.scss'
const Button = ({
    label,
    clickHandler,
    variant = 'primary',
    type = 'button',
    extraCss = null
}) => {
    return (
        <button
            className={`trip-btn trip-btn--${variant} ${extraCss !== null ? extraCss : ''}`}
            type={type}
            onClick={clickHandler}
        >
            {label}
        </button>
    )
}

Button.propTypes = {
    label: PropTypes.string.isRequired,
    clickHandler: PropTypes.func,
    variant: PropTypes.oneOf(['primary', 'secondary', 'none', 'remove']),
    type: PropTypes.oneOf(['submit', 'button', 'reset']),
    extraCss: PropTypes.string,
};

export default Button
